import { CreatePlayerRequest } from '../models/player';

class PlayerService {
    public async createPlayer(name: string) {
        try {
            const request: CreatePlayerRequest = {
                name,
            };
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/players`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(request),
            });
            if (!response.ok) {
                throw new Error(`Failed to create player: ${response.status} ${response.statusText}`);
            }
            return {
                body: await response.json(),
                status: response.status,
            };
        } catch (error) {
            console.error('Error creating player:', error);
            throw error;
        }
    }
}

export const playerService = new PlayerService();